import Link, { LinkProps } from 'src/components/atoms/link'
import { EmailIcon } from 'src/components/icons'

import { theme, Tooltip } from 'antd'

const { useToken } = theme

interface Props extends Omit<LinkProps, 'to' | 'children'> {
    email: string
    message?: string
    asIcon?: boolean
}

const EmailLink = (props: Props) => {
    const { email, message, asIcon = false, style, ...rest } = props
    const { token } = useToken()

    if (!email) {
        return <div>—</div>
    }
    const displayMessage = message || email
    return (
        <Link
            {...rest}
            className={'hover:opacity-75'}
            style={{ ...style, color: token.colorPrimary }}
            to={`mailto:${email}`}
            onClick={(e) => e.stopPropagation()}
        >
            {/* Give the possibility to show a custom message instead of the actual email (e.g. "Contact support") */}
            {asIcon ? (
                <Tooltip title={displayMessage}>
                    <EmailIcon />
                </Tooltip>
            ) : (
                displayMessage
            )}
        </Link>
    )
}

export default EmailLink
